module.exports = __webpack_public_path__ + "src/static/MyBodyModel-Color-Swatch.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/MyBodyModel-Color-Swatch.pdf
// module id = 1167
// module chunks = 0